// extracted by mini-css-extract-plugin
module.exports = {"content":"section-divider_content__PZAnP","headline":"section-divider_headline__0_f51","body":"section-divider_body__BP59j"};